// imports section Start
import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
// imports section End
function DynamicBarChart({ dataset = null }) {
  return (
    <>
      {dataset ? (
        <BarChart
          height={300}
          series={[
            {
              data: dataset.map((item) => item.y),
              color: dataset.map((item) => item.color), // Add color mapping if required
            },
          ]}
          xAxis={[
            {
              data: dataset.map((item) => item.x), // Use order types as X-axis data
              scaleType: "band", // Set to 'band' for categorical data
            },
          ]}
          margin={{ left: 70, right: 30, top: 10, bottom: 30 }}
          grid={{ vertical: false, horizontal: true }}
        />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default DynamicBarChart;
